<template>
  <div class="item-container">
    <div
      class="item-main"
      :class="{'item-active': dropdown}"
    >
      <div class="item-title">
        <span>CHECK-IN INFORMATION</span>
      </div>
      <div class="toggle">
        <span
          v-if="!dropdown"
        >+</span>
        <span
          v-else
        >-</span>
      </div>
    </div>
    <div
      v-if="dropdown"
      class="item-dropdown"
    >
      <div class="item-dropdown-main">
        <div class="vtd-row vtd-my-3">
          <div class="vtd-col-12 vtd-col-md">Departing from {{ item.airport }}, Terminal {{
              item.terminal
            }}<br/>
            Minimum check-in requirement: {{ item.time }} before
            departure
          </div>
        </div>

      </div>
      <div
        v-if="item.fnotes[0]"
        class="extra-info-notes"
      >
        Notes
        <ul>
          <li
            v-for="(note, index) in item.fnotes"
            :key="index"
          >
            {{ note }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dropdown: true,
    }
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
  methods: {
    toggleExpand () {
      this.dropdown = !this.dropdown
    },
    collapseAll () {
      this.dropdown = false
    },
    expandAll () {
      this.dropdown = true
    }
  }
};
</script>

<style lang="scss">
  @import './styles.scss';

</style>
